import { Machine, assign, actions } from 'xstate'
import { v4 as uuidv4 } from 'uuid'

const { raise } = actions

const track = (eventName) => ({
  type: 'trackInAnalytics',
  eventName,
})

const saveResult = (suggestion) => ({
  type: 'saveSmartScreenerResultsResults',
  suggestion
})

const createScreenerID = () => localStorage.meruScreenerID = uuidv4()

const isPHQ2orGAD2High = (ctx) => ctx.phq9 >= 3 || ctx.gad7 >= 3


const assessmentMachine = Machine(
  {
    id: 'assessment',
    initial: 'phq9',
    context: {
      phq9: 0,
      gad7: 0,
      pss: 0,
      brs: 0,
      who5: 0,
      answers: [],
      isSuicidal: false
    },
    states: {
      phq9: {
        id: 'phq9',
        initial: 'short',
        entry: [createScreenerID, track('phq9')],
        on: {
          PHQ9: {
            actions: ['addPHQ9', raise('NEXT')],
          },
          NEXT: [
            { cond: 'isPHQ2orGAD2High', target: '#therapy' },
            { target: '#gad7' },
          ],
        },
        states: {
          short: {
            initial: 'phq9_1',
            states: {
              phq9_1: {
                on: {
                  NEXT: 'phq9_2',
                },
              },
              phq9_2: {},
            },
          },
        },
      },
      gad7: {
        id: 'gad7',
        initial: 'short',
        on: {
          GAD7: {
            actions: ['addGAD7', raise('NEXT')],
          },
          NEXT: [
            { cond: 'isPHQ2orGAD2High', target: '#therapy' },
            { target: '#mhq' },
          ],
        },
        states: {
          short: {
            initial: 'gad7_1',
            states: {
              gad7_1: {
                on: {
                  NEXT: 'gad7_2',
                },
              },
              gad7_2: {},
            },
          },
        },
      },
      mhq: {
        id: 'mhq',
        initial: 'mhq_1',
        entry: track('mhq'),
        on: {
          YES: {
            target: '#therapy',
            actions: ['addYes'],
          },
          NO: {
            actions: ['addNo', raise('NEXT')],
          },
          NEXT: '#coaching',
        },
        states: {
          mhq_1: {
            on: {
              YES: {
                target: '#additionalSupport',
                actions: ['addYes'],
              },
              NEXT: 'mhq_2',
            },
          },
          mhq_2: {
            on: {
              NEXT: 'mhq_5',
            },
          },
          mhq_5: {
            on: {
              NEXT: 'mhq_6',
            },
          },
          mhq_6: {},
        },
      },
      additionalSupport: {
        entry: [track('suicidal'), context => context.isSuicidal = true],
        id: 'additionalSupport',
        on: {
          NEXT: '#therapy',
        }
      },
      coaching: {
        id: 'coaching',
        type: 'final',
        entry: [track('coaching'), saveResult('coaching')],
      },
      therapy: {
        id: 'therapy',
        type: 'final',
        entry: [track('therapy'), saveResult('therapy')],
      },
    },
  },
  {
    actions: {
      addPHQ9: assign({
        phq9: (ctx, e) => ctx.phq9 + e.answer,
        answers: (ctx, e) => [...ctx.answers, { question: e.question, answer: e.answer }],
      }),
      addGAD7: assign({
        gad7: (ctx, e) => ctx.gad7 + e.answer,
        answers: (ctx, e) => [...ctx.answers, { question: e.question, answer: e.answer }],
      }),
      addYes: assign({
        answers: (ctx, e) => [...ctx.answers, { question: e.question, answer: 1 }],
      }),
      addNo: assign({
        answers: (ctx, e) => [...ctx.answers, { question: e.question, answer: 0 }],
      }),
    },
    guards: {
      isPHQ2orGAD2High
    },
  }
)

export default assessmentMachine
